import React, { useEffect, useState } from "react";
import { YhMultiSelect } from "@/components/YhMultiSelect"
import { useFiltrationModel } from "../filtrationModel";
import { addressSeries, dataSourceSeries, timeSeries, pubTimeSeries,gatherStatusSeries } from "../seriesData";
import { IFiltrationSeachFields } from "../filtrationService";
import { webSiteService } from "@/views/webSite/webSiteService";
import useGlobalModel from "@/model/globalModel";

export interface ISearchSeriesType {
	"title": string,    // "天津",
	"value": string,    // "2",
	"active": boolean,    // false
}

export function PageHeader() {
	const {
		searchParam,
		setSearchParam,
		loadData,
		showOne, setShowOne
	} = useFiltrationModel();
	const { address } = useGlobalModel();
	const [sourceSeries, setSourceSeries] = useState<ISearchSeriesType[]>([{ "title": "全部", "value": "", "active": true }]);

	const getSeriesDs = async () => {
		let { retData } = await webSiteService.page({ pageNum: 1, pageSize: -1 });
		let { records } = retData;
		retData && setSourceSeries((origin) => {
			let currentArr = records.map(item => ({
				"title": item.name ?? "",    // "天津",
				"value": item.id ?? "",    // "2",
				"active": false,    // false
			}))
			return [...origin, ...currentArr];
		})
	}

	useEffect(() => {
		getSeriesDs();
	}, []);


	const searchSeriesFields = [
		{
			field: "region",
			title: "地区",
			typeList: address
		},
		{
			field: "sourceFrom",
			title: "数据来源",
			typeList: sourceSeries
		},
		{
			field: "date",
			title: "截止日期",
			typeList: timeSeries
		},
		{
			field: "pubDate",
			title: "采集日期",
			typeList: pubTimeSeries
		},
		{
			field: "gatherStatus",
			title: "采集状态",
			typeList: gatherStatusSeries
		},
	]
	const handleShowOne = () => {
		setShowOne(origin => !origin);
	}
	return (
		<YhMultiSelect
			seriesDataSaurce={searchSeriesFields}
			filterFields={searchParam}
			setFilterFields={setSearchParam}
			onChange={(obj: IFiltrationSeachFields) => loadData({ pageNum: 1 }, obj)}
			isShowOne={showOne}
			handleShowOne={handleShowOne}
		/>
	);
}